import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGuardian, useRouter, useTranslate } from "@bluelibs/x-ui";
import React, { useEffect, useState } from "react";
import { Routes } from "@bundles/UIAppBundle";
import { Row, Col, Alert, Card, } from "antd";
export function VerifyEmail(props) {
    const { token } = props;
    const guardian = useGuardian();
    const router = useRouter();
    const tl = useTranslate("authentication.verifyEmail");
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [isVerifyingEmail, setIsVerifyingEmail] = useState(true);
    const [emailVerificationError, setEmailVerificationError] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            guardian
                .verifyEmail(token)
                .then(() => {
                setIsVerifyingEmail(false);
                setIsEmailVerified(true);
                setTimeout(() => {
                    router.go(Routes.HOME);
                }, 3500);
            })
                .catch((err) => {
                setIsVerifyingEmail(false);
                setEmailVerificationError(err.toString());
            });
        }, 1000);
    }, []);
    const style = { minHeight: "100vh" };
    return (_jsx(Row, { justify: "center", align: "middle", style: style, className: "verify-email-page", children: _jsx(Col, { sm: 24, md: 12, lg: 6, children: _jsxs(Card, { title: tl("header"), children: [isVerifyingEmail && _jsx(Alert, { message: tl("verifying") }), isEmailVerified && _jsx(Alert, { type: "success", message: tl("success") }), emailVerificationError && (_jsx(Alert, { type: "error", message: tl("errored") }))] }) }) }));
}
